export const FACT_FIND_HEADINGS_VALUES = {
  YOUR_GOAL: 1,
  YOUR_DETAILS: 2,
  YOUR_HOUSEHOLD: 3,
  CO_APPLICATIONS: 4,
  YOUR_HOME: 5,
  TO_PURCHASE: 6,
  OTHER_PROPERTIES: 7,
  ASSETS: 8,
  LIABILITIES: 9,
  INCOME: 10,
  EXPENSES: 11,
  ADDRESS_HISTORY: 12,
  EMPLOYMENT_HISTORY: 13,
  FORSEEABLE_CHANGES: 14,
  CREDIT_HISTORY: 15,
  SUPPORTING_DOCUMENTS: 16,
  PRIVACY_POLICY: 21,
};

export const FACT_FIND_GROUPING = {
  GROUP_1: 1,
  GROUP_2: 2,
  GROUP_3: 3,
  GROUP_4: 4,
};

export const FACT_FIND_HEADINGS_GROUP = {
  21: FACT_FIND_GROUPING.GROUP_1,
  1: FACT_FIND_GROUPING.GROUP_1,
  2: FACT_FIND_GROUPING.GROUP_1,
  3: FACT_FIND_GROUPING.GROUP_1,
  4: FACT_FIND_GROUPING.GROUP_1,
  5: FACT_FIND_GROUPING.GROUP_2,
  6: FACT_FIND_GROUPING.GROUP_2,
  7: FACT_FIND_GROUPING.GROUP_2,
  8: FACT_FIND_GROUPING.GROUP_3,
  9: FACT_FIND_GROUPING.GROUP_3,
  10: FACT_FIND_GROUPING.GROUP_3,
  11: FACT_FIND_GROUPING.GROUP_3,
  12: FACT_FIND_GROUPING.GROUP_4,
  13: FACT_FIND_GROUPING.GROUP_4,
  14: FACT_FIND_GROUPING.GROUP_4,
  15: FACT_FIND_GROUPING.GROUP_4,
  16: FACT_FIND_GROUPING.GROUP_4,
};
